elabs.SecondaryNavigationMenu = class {
  constructor() {
    this.initialise();
  }

  initialise = () => {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.el-account-link');
      if (!trigger) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      elabs.overlayMenuService.showMenu({ templateId: 'el-account-menu' }, 'right');
    });
  };
};

elabs.onJavascriptReady(() => {
  elabs.SecondaryNavigationMenu = new elabs.SecondaryNavigationMenu();
});
